module.exports = __webpack_public_path__ + "static/img/piglet1.83ffafa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/piglet1.png
// module id = 8n88
// module chunks = 2